import { Controller } from "@hotwired/stimulus"

// Desktop/mobile toggle for the Review-step email preview — swaps a width class
// on the preview frame so the organizer can see how the email reads on a phone.
export default class extends Controller {
  static targets = ["frame"]

  desktop(event) { this.setDevice("desktop", event) }
  mobile(event) { this.setDevice("mobile", event) }

  setDevice(device, event) {
    if (this.hasFrameTarget) this.frameTarget.classList.toggle("is-mobile", device === "mobile")
    this.element.querySelectorAll(".device-btn").forEach((b) =>
      b.classList.toggle("active", b.dataset.device === device))
  }
}
